import { SliderField } from './SliderField';
import { useNode } from '@craftjs/core';
import { editorRegistry } from '@/components/userComponents/Text';
import { applyMark } from '@/utils/textUtils';
import { Editor as SlateEditor } from 'slate';
import type { ButtonProps } from '@builder4/shared/components/Button';
import { isTextBlockNode } from '@/utils/helperFunc';

const NodeTextSizeSettings = ({ text = 'Text Size' }: { text?: string }) => {
  const {
    id,
    props,
    actions: { setProp },
    node,
  } = useNode((node) => ({
    id: node.id,
    props: node.data.props,
    node: node,
  }));

  const getFontSize = () => {
    if (isTextBlockNode(node)) {
      const slateEditor = editorRegistry.get(id);
      if (!slateEditor) return;
      const { editor } = slateEditor;
      const marks = SlateEditor.marks(editor);
      const value =
        marks != undefined && Object?.keys(marks)?.length > 0 && marks['fontSize'] != undefined
          ? marks['fontSize']
          : '';
      const finalFontSize = parseInt(value?.replace?.('px', '') || '0', 10);
      return finalFontSize;
    } else {
      const finalFontSize = parseInt(props.fontSize?.replace?.('px', '') || '0', 10);
      return finalFontSize;
    }
  };

  const handleOnChange = (value: number) => {
    if (isTextBlockNode(node)) {
      const slateEditor = editorRegistry.get(id);
      if (!slateEditor) return;
      const { editor } = slateEditor;
      applyMark(editor, 'fontSize', `${value}px`);
    } else {
      setProp((props: Partial<ButtonProps>) => {
        props.fontSize = `${value}px`;
      }, 500);
    }
  };

  return (
    <SliderField
      label={text}
      value={getFontSize()}
      onChange={handleOnChange}
      onChangeComplete={handleOnChange}
      min={0}
      max={100}
    />
  );
};

export default NodeTextSizeSettings;
